<template>
    <div>
        <!--Edit-->
        <Loader v-if="isLoading"></Loader>
        <div class="container">
            <div class="page-inner">
                <div class="page-header gp-admin-page-heading">
                    <h3 class="fw-bold">Recarga de Consultas</h3>
                    <ul class="breadcrumbs">
                        <li class="nav-home"> <router-link to="/home"><i class="fa fa-home"></i></router-link> </li>
                        <li class="separator"><i class="fa fa-chevron-right"></i> </li>
                        <li class="nav-item"><a href="#" @click.prevent="EditCancel()">Recarga de Consultas de
                                crédito</a>
                        </li>
                    </ul>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="card">
                            <div class="gp-admin-form-header">
                                <span><v-icon size="20">mdi-credit-card-plus-outline</v-icon></span>
                                <div>
                                    <h4>Recarga de consultas</h4>
                                    <p>Selecione a garantidora e informe as quantidades dos produtos que deseja contratar.</p>
                                </div>
                            </div>
                            <div class="card-body gp-recharge-body">
                                <v-form>
                                    <v-container>
                                        <div class="row gp-recharge-form">
                                            <!-- Seleção de Garantidora -->
                                            <div class="col-md-3 col-lg-3" v-if="User.garid === 0">
                                                <div class="form-group">
                                                    <label>Garantidora</label>
                                                    <v-autocomplete v-model="GarantidoraSelecionadaId" :items="ListGarantidorasGeral"
                                                        item-title="garNomeEmpresa" item-value="garId" density="compact"
                                                        variant="outlined" placeholder="Digite para pesquisar" clearable hide-details
                                                        no-data-text="Nenhuma garantidora encontrada" @update:model-value="SelecionarGarantidora" />
                                                </div>
                                            </div>

                                            <!-- Listagem dos Produtos Consultas -->
                                            <div class="col-md-12 col-lg-12"
                                                v-if="ProdutosConsultasFor && ProdutosConsultasFor.length">
                                                <div class="gp-recharge-products">
                                                <!-- Cabeçalho da "tabela" -->
                                                <div class="row font-weight-bold gp-recharge-products__header">
                                                    <div class="col-md-3">Produto</div>
                                                    <div class="col-md-3">Valor Unitário</div>
                                                    <div class="col-md-3">Quantidade</div>
                                                    <div class="col-md-3">Total</div>
                                                </div>

                                                <!-- Itens (v-for) -->
                                                <div class="row gp-recharge-products__row" v-for="produto in ProdutosConsultasFor" :key="produto.cpcId">
                                                    <div class="col-md-3">
                                                        {{ produto.cpcNomeProduto }}
                                                    </div>
                                                    <div class="col-md-3">
                                                        R$ {{  formatarValor(produto.cpcValor) }}
                                                    </div>
                                                    <div class="col-md-3">
                                                        <input type="number" v-model.number="produto.cpcQtde" :disabled="produto.cpcValor == 0"
                                                            class="form-control" min="0" />
                                                    </div>
                                                    <div class="col-md-3">
                                                        R$ {{  formatarValor((produto.cpcValor * produto.cpcQtde)) }}
                                                    </div>
                                                </div>

                                                <!-- Total Geral -->
                                                <div class="row">
                                                    <div class="col-md-12 text-right gp-recharge-total">
                                                        <strong>Total Geral: R$ {{  formatarValor(totalGeral) }}</strong>
                                                    </div>
                                                </div>
                                                </div>
                                            </div>
                                            <div class="col-md-12 col-lg-12 gp-recharge-actions" v-if="totalGeral!=0">
                                                <a href="#" @click="EditCancel()" class="btn btn-outline-secondary">Cancelar</a>
                                                <button type="button" class="btn btn-success" style="color:#ffffff;" :disabled="isLoading" @click="Contratar()">
                                                    <v-icon size="16">mdi-credit-card-check-outline</v-icon> Contratar e gerar link de pagamento
                                                </button>
                                            </div>
                                        </div>
                                    </v-container>
                                </v-form>
                            </div>
                            <div class="card-header" v-if="ContratacaoAndamento!= '' && Garantidora !=''">
                                <div class="d-flex align-items-center">
                                    <h4 class="card-title">Contratações Pendentes de Pagamento</h4>
                                </div>
                            </div>
                            <div class="card-body" v-if="ContratacaoAndamento!= '' && Garantidora !=''">
                                <adm-data-table :headers="headers" :items="GridContratacao" v-model="itemsSelected" alternating
                                    :show-filters="false"
                                    :show-export="false"
                                    theme-color="#364f66" table-class-name="customize-table" header-text-direction="center"
                                    body-text-direction="center" rows-per-page-message="Linhas por pagina" file-name="recargas-pendentes">
                                    <template #item-ultimoStatus="item">
                                        <span>{{ item.ultimoStatus == 1 ? 'Pago' : item.ultimoStatus == -1 ? 'Expirado' : 'Pendente' }}</span>
                                    </template>
                                    <template #item-valorTotal="item">
                                        <span> R$ {{ formatarValor(item.valorTotal) }}</span>
                                    </template>
                                    <template #item-actions="item">
                                        <div class="gp-table-actions"><a v-if="item.ultimoLink" :href="item.ultimoLink" target="_blank"
                                            class="gp-table-action gp-action-edit" title="Abrir pagamento"><v-icon size="17">mdi-credit-card-outline</v-icon></a></div>
                                    </template>
                                </adm-data-table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import Loader from '../../components/PageLoader.vue'
import EasyDataTable from 'vue3-easy-data-table'

export default {
  name: 'RecargaConsultasView',
  components: {
    moment,
    Loader,
    EasyDataTable
  },
  data: () => ({
    isLoading: false,
    User: {
      garid: 0,
      tpeid: 0
    },
    NomeTela: 'Recarga Consultas',
    InfoTela: 'Recarga Consultas',
    // dados
    Garantidora: {},
    GarantidoraSelecionadaId: null,
    ListGarantidorasGeral: [],
    ProdutosConsultas: [],
    Serasa: {
      gseId: 0,
      grtId: 0,
      cdtId: 0,
      gsePropriedade: 0,
      gseQtdeMensal: '',
      gseCustoPesExtra: null,
      gseQtdeGratisMensal: 0,
      gseRangeAprovacao: 0,
      garId: 0
    },
    Processos: {
      gprId: 0,
      grtId: 0,
      cdtId: 0,
      gprPropriedade: 0,
      gprQtdeMensal: '',
      gprCustoPesExtra: null,
      gprQtdeGratisMensal: 0,
      garId: 0
    },
    Assinatura: {
      gasId: 0,
      grtId: 0,
      cdtId: 0,
      gasPropriedade: '',
      gasQtdeMensal: '',
      gasCustoPesExtra: 0,
      gasQtdeGratisMensal: 0,
      gasIdRepositorio: '',
      gasToken: '',
      garId: ''
    },
    valorCredito: 0,
    valorAssinatura: 0,
    ProdutosConsultasFor: [],
    headers: [
      { text: 'Contratacao', value: 'idContratacao', sortable: true },
      { text: 'ValorTotal', value: 'valorTotal' },
      { text: 'Status', value: 'ultimoStatus' },
      { text: 'Link', value: 'ultimoLink' },
      { text: 'Ações', value: 'actions' }
    ],
    ContratacaoAndamento: [],
    GridContratacao: []
  }),
  methods: {
    SelecionarGarantidora (garId) {
      this.Garantidora = this.ListGarantidorasGeral.find(item => item.garId == garId) || {}
      if (this.Garantidora.garId) this.BuscaListaProdutos()
      else {
        this.ProdutosConsultasFor = []
        this.ContratacaoAndamento = []
        this.GridContratacao = []
      }
    },
    startLoading () {
      this.isLoading = true
    },
    stopLoading () {
      this.isLoading = false
    },
    formattedDate (value) {
      if (value != null || value != '') {
        return this.$moment(value).format('DD/MM/YYYY')
      } else {
        return ''
      }
    },
    formatarValor (valor) {
      return valor.toLocaleString('pt-BR', { minimumFractionDigits: 2 })
    },
    async BuscaListaProdutos () {
      await axios.get('/Telas/RecargaConsultas/GetByGarIdSerasa/' + this.Garantidora.garId)
        .then(response => {
          this.Serasa = response.data[0]
          // console.log('this.Serasa')
          // console.log(this.Serasa)
        })

      await axios.get('/Telas/RecargaConsultas/GetByGarIdProcessos/' + this.Garantidora.garId)
        .then(response => {
          this.Processos = response.data[0]
          // console.log('this.Processos')
          // console.log(this.Processos)
        })

      await axios.get('/Telas/RecargaConsultas/GetByGarIdAssinaturas/' + this.Garantidora.garId)
        .then(response => {
          this.Assinatura = response.data[0]
          // console.log('this.Assinatura')
          // console.log(this.Assinatura)
        })

      if (this.Assinatura != '' && this.Assinatura != null) {
        this.valorAssinatura = this.Assinatura.gasCustoPesExtra
      } else {
        this.valorAssinatura = 0
      }
      if ((this.Processos != '' && this.Processos != null) && (this.Serasa != '' && this.Serasa != null)) {
        this.valorCredito = this.Processos.gprCustoPesExtra + this.Serasa.gseCustoPesExtra
      } else {
        this.valorCredito = 0
      }
      this.ProdutosConsultasFor = []
      this.ProdutosConsultasFor = this.ProdutosConsultas.map(x => {
        if (x.cpcId === 1) {
          x.cpcValor = this.valorAssinatura
          x.cpcQtde = 0
        } else if (x.cpcId === 2) {
          x.cpcValor = this.valorCredito
          x.cpcQtde = 0
        } else {
          x.cpcValor = 0
          x.cpcQtde = 0
        }
        return x
      })

      this.EditGrid()
    },
    EditGrid () {
      axios.get('/Telas/RecargaConsultas/GetByGarIdPgtoConsulta/' + this.Garantidora.garId)
        .then(response => {
          this.ContratacaoAndamento = response.data.filter(x => x.gpaStatusPgto == 0)

          const grouped = this.ContratacaoAndamento.reduce((acc, item) => {
            if (!acc[item.gpaIdContratacao]) acc[item.gpaIdContratacao] = []
            acc[item.gpaIdContratacao].push(item)
            return acc
          }, {})

          const result = Object.keys(grouped).map(key => {
            const groupItems = grouped[key]
            groupItems.sort((a, b) => new Date(a.gpaDataContratacao) - new Date(b.gpaDataContratacao))
            const lastItem = groupItems[groupItems.length - 1]
            const totalValor = groupItems.reduce((sum, record) => sum + parseFloat(record.gpaValorTotal), 0)
            return {
              idContratacao: key,
              valorTotal: totalValor,
              ultimoStatus: lastItem.gpaStatusPgto,
              ultimoLink: lastItem.gpaLinkPgto
            }
          })

          this.GridContratacao = result
        })
    },
    async Contratar () {
      if (this.isLoading) return
      const produtos = this.ProdutosConsultasFor.filter(x => Number(x.cpcQtde) > 0).map(x => ({ ...x }))
      const garId = this.Garantidora.garId
      if (!garId || !produtos.length) return this.$mensagemAviso('Selecione a garantidora e informe a quantidade de créditos.')
      this.startLoading()
      const idContratacao = garId + moment().format('YYYYMMDDTHHmmssSSS')
      try {
        // Só solicitar o link depois que todos os produtos forem gravados com sucesso.
        for (const element of produtos) {
          const contratacao = {
            GpaId: 0, GarId: garId, CpcId: element.cpcId,
            GpaIdContratacao: idContratacao, GpaCodProdutoDelta: element.cpcCodProdutoDelta,
            GpaQtdeContratada: element.cpcQtde, GpaValorUnitario: element.cpcValor,
            GpaValorTotal: element.cpcQtde * element.cpcValor,
            GpaQtdeSaldo: 0, GpaStatusPgto: 0,
            GpaDataContratacao: moment().format('YYYY-MM-DDTHH:mm:ss'), TopId: 1
          }
          const response = await axios.post('/Telas/RecargaConsultas/AddPgtoConsulta', contratacao, { showError: false })
          if (!(Number(response.data) > 0)) throw new Error('Não foi possível gravar todos os produtos. O link não foi solicitado.')
        }
        const response = await axios.post('/Telas/RecargaConsultas/CreateInvoiceGarantePay/' + garId + '/' + idContratacao, null, { showError: false })
        if (response.data == 1 || response.data == 5) {
          this.$mensagemAvisoSucesso('Link de Pagamento Gerado.')
        } else {
          const mensagens = { 2: 'Erro no cadastro do cliente para pagamento. Consulte o administrador.', 3: 'Erro na geração do link de pagamento. Consulte o administrador.', 4: 'Erro no retorno do link de pagamento. Consulte o administrador.' }
          throw new Error(mensagens[response.data] || 'Não foi possível confirmar a geração do link de pagamento.')
        }
        await this.BuscaListaProdutos()
      } catch (err) {
        await this.$mensagemErro(err.response?.data?.message || err.response?.data?.Message || err.message || 'Não foi possível concluir a recarga.', { confirmButtonText: 'OK', allowOutsideClick: false })
      } finally {
        this.stopLoading()
      }
    },
    EditCancel () {
      this.$router.go(0)
    },
    async Get () {
      await axios.get('/Telas/RecargaConsultas/GetDados')
        .then(response => {
          this.ProdutosConsultas = response.data.cadProdutoConsulta.filter(x => x.cpcAtivo)
          this.ListGarantidorasGeral = response.data.garGarantidoras.filter(x => x.garVisivel).sort((a, b) =>
            a.garNomeEmpresa.localeCompare(
              b.garNomeEmpresa,
              'pt',
              { sensitivity: 'base' }
            )
          )
          this.User.garid = response.data.garId
          if (this.User.garid != 0) {
            this.Garantidora = this.ListGarantidorasGeral.filter(x => x.garId == this.User.garid)[0]
            this.GarantidoraSelecionadaId = this.User.garid
            this.BuscaListaProdutos()
            this.EditGrid()
          }
        })
    }
  },
  created () {
    this.Get()
  },
  computed: {
    totalGeral () {
      return this.ProdutosConsultasFor.reduce((total, produto) => {
        return total + (produto.cpcValor * produto.cpcQtde)
      }, 0)
    }
  }
}
</script>

<style scoped>
.tabinfo {
    font-size: 14px;
    text-transform: capitalize;
}
.gp-recharge-body { padding-top: 12px; }
.gp-recharge-body :deep(.v-container) { max-width: none; padding: 0; }
.gp-recharge-form > [class*="col-"] { padding-top: 4px; padding-bottom: 4px; }
.gp-recharge-products { margin-top: 8px; overflow: hidden; border: 1px solid #e1d9cd; border-radius: 11px; background: #fffdf9; }
.gp-recharge-products__header { margin: 0; padding: 9px 10px; background: #f1ece4; color: #596478; font-size: 9px; font-weight: 800; letter-spacing: .05em; text-transform: uppercase; }
.gp-recharge-products__row { align-items: center; margin: 0; padding: 7px 10px; border-top: 1px solid #ebe5dc; color: #465168; font-size: 11px; }
.gp-recharge-products__row .form-control { min-height: 34px; }
.gp-recharge-total { padding: 11px 14px; border-top: 1px solid #e1d9cd; background: #fcf8f2; color: #183765; font-size: 12px; }
.gp-recharge-actions { display: flex; align-items: center; justify-content: flex-end; gap: 8px; padding-top: 10px !important; }
.gp-recharge-actions .btn { display: inline-flex; align-items: center; justify-content: center; gap: 5px; }
@media (max-width: 767.98px) { .gp-recharge-products__header { display: none; } .gp-recharge-products__row { gap: 5px; } .gp-recharge-products__row > div { width: 100%; } .gp-recharge-actions { align-items: stretch; flex-direction: column; } .gp-recharge-actions .btn { width: 100%; } }
</style>
